import { CircularProgress } from '@material-ui/core';
import api from 'api';
import React, { useState } from 'react';
import { Notify } from 'utils';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

interface KiidDocumentButtonProps {
  isin: string;
}

const KiidDocumentButton = ({ isin }: KiidDocumentButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const getKiidDocument = (isin: any) => {
    setIsLoading(true);
    api
      .getKiidDocument({ isin })
      .then(({ data }: any) => {
        const w = window.open(data.kiid, '_blank');
        if (w) {
          w.focus();
        }
      })
      .catch((err: any) => {
        Notify.error(err.response.data.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading ? (
        <CircularProgress size="20px" />
      ) : (
        <DescriptionOutlinedIcon
          onClick={() => getKiidDocument(isin)}
          style={{ cursor: 'pointer', color: '#000' }}
        />
      )}
    </>
  );
};

export default KiidDocumentButton;
